/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { Action, createAction } from '@ngrx/store';

import { UserPassword } from '../../../entities/auth/auth.entities';

export const ADD_ID_TOKEN = '[USER] addIdToken';
export const ADD_REFRESH_ID = '[USER] addRefreshId';

export const INIT_USER = '[AUTH] Init User';
export const REQUEST_LOGIN = '[AUTH] Request Login';
export const LOGIN_SERVICE_DONE = '[AUTH] Login Service Processing';
export const LOGIN_SERVICE_ERROR = '[AUTH] Login Service ERROR';

export const START_MFA = '[AUTH] Start Mfa process';
export const MFA_WRITTEN = '[AUTH] Mfa written';
export const MFA_COMPLETE = '[AUTH] MFA COMPLETE';
export const MFA_FAIL = '[AUTH] MFA_FAIL';

export const REMOVE_USER = '[USER] Remove';

export const SEND_GLOBAL_MESSAGE = '[MESSAGE] MESSAGE SENT';

export const addIdToken = createAction('[Auth] Add ID Token');

export class SendGlobalMessage implements Action {
  readonly type = SEND_GLOBAL_MESSAGE;
  constructor(public payload: any) {}
}
export class StartMfaProcess implements Action {
  readonly type = START_MFA;
  constructor(public payload: any) {}
}

export class MfaWrittenProcess implements Action {
  readonly type = MFA_WRITTEN;
  constructor(public payload: any) {}
}

export class MfaComplete implements Action {
  readonly type = MFA_COMPLETE;
  constructor(public payload: string) {}
}

export class MfaFailed implements Action {
  readonly type = MFA_FAIL;
  constructor(public payload: string) {}
}

export class AddUserId implements Action {
  readonly type = ADD_ID_TOKEN;
  constructor(public payload: string) {}
}
export class InitUser implements Action {
  readonly type = INIT_USER;
  constructor(public payload: any) {}
}

export class RequestLogin implements Action {
  readonly type = REQUEST_LOGIN;
  constructor(public payload: UserPassword) {}
}

export class LoginServiceProcessing implements Action {
  readonly type = LOGIN_SERVICE_DONE;
  constructor(public payload: any) {
    localStorage.setItem('loginDateTime', new Date().getTime().toString());
  }
}

export class LoginServiceError implements Action {
  readonly type = LOGIN_SERVICE_ERROR;
  constructor(public payload: any) {}
}

export class RemoveUser implements Action {
  readonly type = REMOVE_USER;

  constructor(public payload: number) {}
}

export type Actions =
  | SendGlobalMessage
  | AddUserId
  | RemoveUser
  | RequestLogin
  | LoginServiceProcessing
  | LoginServiceError
  | StartMfaProcess
  | MfaWrittenProcess
  | MfaComplete
  | MfaFailed;

/* PavCon, LLC Proprietary.All rights reserved 2022 */
